<template>
  <WFApp
    id="app"
    class="h-screen w-full flex flex-col overflow-hidden items-stretch"
    @screensaving="screensaving"
    :class="{
      'wf-mobile': mobile,
      'accessible-layout-wrapper': accessibleLayout && !mobile,
    }"
  >
    <Header
      :accessibleLayout="accessibleLayout"
      class="px-12 lg:basis-84 grow-0 shrink-0"
    ></Header>
    <div class="h-full lg:flex lg:flex-row lg:flex-grow shrink overflow-hidden">
      <div
        class="h-full lg:h-auto lg:basis-2/3 grow shrink-0 lg:pl-12 lg:pb-12"
      >
        <MapPage
          class="overflow-hidden"
          @accessibleLayoutClick="setAccessibleLayout"
          @loaded="mapLoaded"
          @popupClicked="popupClicked"
          @poiClicked="poiClicked"
        ></MapPage>
      </div>
      <div
        class="wf-menu lg:basis-1/3 shrink-0 overflow-hidden"
        :class="{ 'wf-active': menuVisible || !mobile }"
        id="app-menu"
      >
        <div
          class="menu-handler"
          v-touch:tap="toggleMenu"
          v-touch:swipe.top="showMenu"
          v-touch:swipe.bottom="hideMenu"
        >
          <div class="menu-handler-inner"></div>
        </div>
        <div
          class="h-full overflow-y-scroll lg:overflow-hidden flex flex-col app-menu-inner"
        >
          <div
            v-if="!accessibleLayout || isMobile"
            v-touch:swipe.top="showMenu"
            v-touch:swipe.bottom="hideMenu"
          >
            <TopLevelGroups
              @clicked="showMenu"
              :currentTab="currentTab"
            ></TopLevelGroups>
          </div>
          <div v-if="accessibleLayout" style="height: 45%" class="pb-24">
            <WFBanner
              class="banners-screensaver"
              template="default"
              container="screensaver"
              :playOnBoot="true"
            ></WFBanner>
          </div>
          <div
            class="w-full tabs-wrapper flex-1 overflow-y-auto overflow-x-hidden p-24"
            v-if="!currentPOI"
          >
            <div
              class="tab-item h-full"
              v-if="currentTab == 'grouppois' || currentTab == 'info'"
            >
              <MapPOIs @directionsOpened="directionsOpened"></MapPOIs>
            </div>
            <div class="tab-item h-full" v-if="currentTab == 'flights'">
              <Flights></Flights>
            </div>
            <div class="tab-item h-full" v-if="currentTab == 'offers'">
              <Offers></Offers>
            </div>
            <div class="tab-item h-full" v-if="currentTab == 'search'">
              <Search
                @clicked="poiClicked"
                :accessibleLayout="accessibleLayout"
                @close="hideMenu"
              ></Search>
            </div>
          </div>
          <div
            class="w-full tabs-wrapper flex-1 overflow-y-auto overflow-x-hidden px-18 lg:px-24"
            v-if="currentPOI"
          >
            <div class="tab-item h-full">
              <SinglePOI
                @directionsOpened="directionsOpened"
                ref="singlePOIComponent"
                :currentPOI="currentPOI"
                :defaultDirectons="defaultDiretionsOpened"
                :setCurrentPOI="backFromPOI"
              ></SinglePOI>
            </div>
          </div>
          <TopLevelGroups
            v-if="accessibleLayout && !isMobile"
            :locationBottom="true"
          ></TopLevelGroups>
        </div>
      </div>
    </div>
  </WFApp>
</template>

<script>
/* global WayfinderAPI */
import { mapState } from "vuex";

import TopLevelGroups from "./components/TopLevelGroups.vue";
import MapPOIs from "./components/MapPOIs.vue";
import MapPage from "./components/MapPage.vue";
import Header from "./components/Header.vue";
import Search from "./components/Search.vue";
import Flights from "./components/Flights.vue";
import Offers from "./components/Offers.vue";
import SinglePOI from "./components/SinglePOI.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    MapPage,
    MapPOIs,
    TopLevelGroups,
    Header,
    Search,
    Flights,
    Offers,
    SinglePOI,
  },
  computed: {
    ...mapState("wf", ["pages", "language", "mobile", "pois"]),
    ...mapState(["currentPOI", "currentGroup", "searchVisible"]),
    currentTab() {
      return this.$store.state.currentPage;
    },
  },
  data() {
    return {
      flightInterval: null,
      isMobile: false,
      menuMouseDown: false,
      currentPage: null,
      mobileMenuPosition: 0,
      pageSlug: "map",
      infoPage: null,
      menuVisible: false,
      accessibleLayout: false,
      defaultDiretionsOpened: false,
    };
  },
  watch: {
    searchVisible() {
      console.log("searchVisible", this.searchVisible);
      if (this.searchVisible) {
        this.currentTab = "search";
      } else {
        this.currentTab = "grouppois";
      }
    },
    "$store.state.currentPage": function () {},
    "$store.state.currentPOI": function () {},
  },
  mounted() {
    this.isMobile = window.innerWidth <= 1024;
    this.mobileMenuPosition = window.innerHeight - 112;
    document.addEventListener("mousemove", (e) => {
      this.handleDragMenu(e);
    });
    document.addEventListener("touchmove", (e) => {
      this.handleDragMenu(e);
    });
    this.fetchFligths();
  },
  created() {
    this.flightInterval = setInterval(() => {
      this.fetchFligths();
    }, 60000);
  },
  destroyed() {
    clearInterval(this.flightInterval);
  },
  methods: {
    screensaving() {
      this.$wayfinder.showKiosk();
      this.$store.dispatch("setCurrentPage", "flights");
      this.$store.dispatch("setSchengenZone", "nonschengen");
      this.setPOI(null);
      this.setAccessibleLayout(false);
      this.$nextTick(() => {
        this.$store.dispatch("setCurrentPage", "grouppois");
        this.$store.dispatch("setSchengenZone", "schengen");
        this.$store.dispatch("setAccessible", false);
      });
    },
    fetchFligths() {
      const doAction = async () => {
        const { data } = await axios.get("/flights/");
        this.$store.dispatch("setFlights", data);
      };
      doAction();
    },
    directionsOpened() {
      this.hideMenu();
    },
    setAccessibleLayout(bool) {
      this.accessibleLayout = bool;
    },
    startDragMenu() {
      if (window.innerWidth > 1024) {
        return;
      }
      this.menuMouseDown = true;
    },
    endDragMenu() {
      if (window.innerWidth > 1024) {
        return;
      }
      this.menuMouseDown = false;
    },
    handleDragMenu(e) {
      if (window.innerWidth > 1024 || !this.menuMouseDown) {
        return;
      }

      let position = 0;

      if (e.type.includes(`touch`)) {
        const { touches, changedTouches } = e.originalEvent ?? e;
        const touch = touches[0] ?? changedTouches[0];
        position = touch.pageY;
      } else if (e.type.includes(`mouse`)) {
        position = e.clientY;
      }

      if (position < 10) {
        position = 10;
      }
      if (position > window.innerHeight - 50) {
        position = window.innerHeight - 50;
      }
      this.mobileMenuPosition = position;
    },
    setPage(page) {
      this.pageSlug = page.slug;
      this.currentPage = page;

      if (page.slug === "map") {
        this.$wayfinder.run();
      }
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    setPageBySlug(slug) {
      this.pageSlug = slug;
    },
    infoPageClicked(page) {
      this.infoPage = page;
      this.pageSlug = "info-page";
    },
    poiClicked(poi) {
      if (poi) {
        this.$wayfinder.showFloor(poi.getFloor());
        this.$wayfinder.clearHighlights();
        this.$wayfinder.setHighlights([poi]);

        this.setPOI(poi);
        if (this.$refs.map) {
          this.$nextTick(() => {
            this.$refs.map.showPOIPopup(poi);
          });
        }
      }
    },
    popupClicked(poi) {
      if (poi) {
        this.defaultDiretionsOpened = false;
        this.$wayfinder.showPath(poi.getNode(), poi);
        this.setPOI(poi);
        this.$refs.singlePOIComponent.openDirections();
      }
    },
    setPOI(poi) {
      this.$store.dispatch("setPOI", poi);
    },
    backFromPOI() {
      this.setPOI(null);
    },
    hasAdvertisements() {
      if (
        this.currentPOI &&
        typeof this.currentPOI.getAdvertisements() == "object" &&
        this.currentPOI.getAdvertisements().length > 0
      ) {
        return true;
      }
      return false;
    },
    mapLoaded() {
      //this.$wayfinderApp.loadPages();
      WayfinderAPI.LIVE_LOCATION = WayfinderAPI.LOCATION;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const destination = urlParams.get("destination-poi");
      this.$wayfinder.events.on("path-start", function () {
        console.log('path-start')
        this.hideMenu();
      });

      if (destination) {
        const split = destination.split("-");
        if (split.length == 2 && split[0] === "poi") {
          for (const poi of this.pois) {
            if (poi.id == parseInt(split[1])) {
              setTimeout(() => {
                this.$wayfinder.showPath(poi.getNode(), poi);
                this.setPOI(poi);
                this.defaultDiretionsOpened = true;
              }, 2000);
            }
          }
        }
      }
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    showMenu() {
      this.menuVisible = true;
    },
    hideMenu() {
      this.menuVisible = false;
    },
  },
};
</script>

<style lang="postcss">
.tab-item {
  padding-bottom: 6.4rem;
}

.accessible-layout-wrapper {
  .tab-item {
    padding-bottom: 1rem;
  }
}

.wf-page-menu {
  .wf-list {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: space-evenly;
  }

  .wf-list-item {
    max-width: 20rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    height: 100%;
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: 500;
    justify-content: center;

    &.wf-active {
      background-color: var(--th-primary);
      color: var(--th-primary-content);
    }
  }

  svg {
    height: 8rem;
    margin-bottom: 2.5rem;
  }
}

.info-menu .wf-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  font-size: 2.4rem;
  width: min-content;
}

.info-menu {
  padding: 2rem;
}

.info-menu .wf-list-item {
  background-color: white;
  display: flex;
  min-width: 32ch;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 2rem;
  padding: 1em;
}

.info-menu .wf-icon {
  width: 6rem;
  height: 6rem;
  margin-right: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-menu .wf-icon svg {
  height: 6rem;
  margin-bottom: 0;
}

.header-nav-buttons {
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-label {
    font-weight: 600;
    margin-top: 0.6rem;
  }
}

@media (max-width: 1024px) {
  #app-menu {
    position: fixed;
    top: 100vh;
    top: 100dvh;
    height: 100%;
    width: 100%;
    left: 0;
    z-index: 1000;
    background: #fff;
    padding-top: 3rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    transition: top 0.5s;

    .menu-handler {
      z-index: 10000;
      text-align: center;
      display: block;
      width: 100%;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      position: absolute;
      top: 0px;
      left: 0px;

      .menu-handler-inner {
        display: inline-block;
        margin: 0 auto;
        height: 4px;
        background: #d3dae6;
        width: 32px;
        border-radius: 1.2rem;
      }
    }

    .mainmenu-item {
      height: 4rem;
      width: 4rem;

      svg {
        width: 1.6rem !important;
        height: 1.6rem !important;
      }
    }

    .app-menu-inner {
      position: relative;
      padding-bottom: 10rem;
    }
  }
}
</style>
